module.exports = __webpack_public_path__ + "img/senias-datensatz-detail.7f246979.png";